import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "w100 ion-text-center headline-5" }, "Submit Check-In", -1)
const _hoisted_2 = { style: {"height":"250px","width":"250px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "w100 ion-text-center" }, " Press the SUBMIT button below to complete your check-in. ", -1)
const _hoisted_4 = {
  key: 1,
  style: {"height":"100px","width":"100px"}
}
const _hoisted_5 = {
  key: 2,
  style: {"height":"72px","width":"100px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_wellness_circle = _resolveComponent("wellness-circle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { class: "align-slide" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "ion-justify-content-center pt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { size: "auto" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_wellness_circle, {
                  scale: "0.9",
                  size: 250,
                  one: _ctx.checkInForm.skipSpirit ? 0 : _ctx.spiritPercent,
                  two: _ctx.checkInForm.skipSocial ? 0 : _ctx.socialPercent,
                  three: _ctx.checkInForm.skipPsych ? 0 : _ctx.psychPercent,
                  four: _ctx.checkInForm.skipBio ? 0 : _ctx.bioPercent
                }, null, 8, ["one", "two", "three", "four"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "mx-4 px-4 mt-1" }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                key: 0,
                class: "mx-4",
                type: "indeterminate"
              }))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}